let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://balance-opr.moleawiz.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://balance-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://balance-opr.moleawiz.com"
} else if (environment === "staging") {
  baseUrl =
    "https://balance-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://balance-opr.moleawiz.com"
} else {
  baseUrl =
    "https://balance-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://balance-opr.moleawiz.com"
}

export { baseUrlOrigin };
export default baseUrl;
